import React from "react";
import styles from "./styles/assettype.module.css";
import { selectLogo } from "./selectLogo";
function AssetType({ asset_type, asset_name, removable = true, onDelete }) {
  const logo = selectLogo(asset_type);
  return (
    <div title={asset_name} className={styles.main}>
      <div
        className={styles.logo}
        style={{ backgroundImage: `url(${logo})` }}
      ></div>
      {removable ? (
        <div style={{ position: "relative" }}>
          <div onClick={onDelete} className={styles.delete}></div>
        </div>
      ) : null}
    </div>
  );
}

export default AssetType;
